"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ObjectTypes = _interopRequireWildcard(require("customer-data-objects/constants/ObjectTypes"));

var _react = require("react");

var _default = _react.PropTypes.oneOf(Object.keys(ObjectTypes));

exports.default = _default;
module.exports = exports.default;